<template>
  <div class="flex flex-col self-center w-full">
    <AppCreditsCard
      :credits-info="getCreditsInfo(item?.amount!)"
      :disable-hover="true"
      :icon="`/icons/${item?.iconName}`"
      :subtitle="item?.subtitle"
      :title="item?.title!"
    />
    <!-- <div class="mt-4 text-center text-regular-14">
      {{ t('label.vat-info') }}
    </div> -->
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n({
  useScope: 'local',
});
const props = defineProps<{ selectedpriceId: string }>();
const isProd = useRuntimeConfig().public.isProd;

const creditItems = [
  {
    /* BASIC 50 */
    amount: 50,
    iconName: 'credit 1.svg',
    priceId: isProd
      ? 'price_1OsuiJD8yuHin9TUR1FaCVGT'
      : 'price_1OlTn0D8yuHin9TUGZ8iZNJn',
    title: t('credits.basic-50.title'),
    subtitle: t('credits.basic-50.subtitle'),
  },
  {
    /* BASIC 250 */
    amount: 250,
    iconName: 'credit 2.svg',
    priceId: isProd
      ? 'price_1OsuiJD8yuHin9TUj6mXej0c'
      : 'price_1OlTn0D8yuHin9TUnawsETrH',
    title: t('credits.basic-250.title'),
    subtitle: t('credits.basic-250.subtitle'),
  },
  {
    /* BASIC 1000 */
    amount: 1000,
    iconName: 'credit 3.svg',
    priceId: isProd
      ? 'price_1OsuiJD8yuHin9TUXzTa3ewS'
      : 'price_1OlTn0D8yuHin9TU9djzg7mu',
    title: t('credits.basic-1000.title'),
    subtitle: t('credits.basic-1000.subtitle'),
  },
  {
    /* PRO 300 */
    amount: 300,
    iconName: 'credit 1.svg',
    priceId: isProd
      ? 'price_1OsuibD8yuHin9TUQE9YYvz9'
      : 'price_1OlTqwD8yuHin9TU29zq1Uo6',
    title: t('credits.pro-300.title'),
    subtitle: t('credits.pro-300.subtitle'),
  },
  {
    /* PRO 1000 */
    amount: 1000,
    iconName: 'credit 2.svg',
    priceId: isProd
      ? 'price_1OsuibD8yuHin9TUuogIut3q'
      : 'price_1OlTqwD8yuHin9TUgq3I68cX',
    title: t('credits.pro-1000.title'),
    subtitle: t('credits.pro-1000.subtitle'),
  },
  {
    /* PRO 2000 */
    amount: 2000,
    iconName: 'credit 3.svg',
    priceId: isProd
      ? 'price_1OsuibD8yuHin9TU97jY5R5s'
      : 'price_1OlTqwD8yuHin9TUkdImv54h',
    title: t('credits.pro-2000.title'),
    subtitle: t('credits.pro-2000.subtitle'),
  },
];

const item = computed(() =>
  creditItems.find((c) => c.priceId === props.selectedpriceId)
);

function getCreditsInfo(amount: number) {
  if (!amount) {
    return '';
  }
  return t('label.amount', { amount: amount / 10 });
}
</script>

<style scoped></style>
<i18n lang="json">
{
  "de": {
    "label": {
      "amount": "entsprechen {amount} Scans",
      "vat-info": "* zzgl. MwSt"
    },
    "credits": {
      "basic-50": {
        "title": "50 Credits (9,50€*)",
        "subtitle": "1,90€*/Scan"
      },
      "basic-250": {
        "title": "250 Credits (45€*)",
        "subtitle": "1,80€*/Scan"
      },
      "basic-1000": {
        "title": "1000 Credits (170€*)",
        "subtitle": "1,70€*/Scan"
      },
      "pro-300": {
        "title": "300 Credits (51€*)",
        "subtitle": "1,70€*/Scan"
      },
      "pro-1000": {
        "title": "1000 Credits (160€*)",
        "subtitle": "1,60€*/Scan"
      },
      "pro-2000": {
        "title": "2000 Credits (300€*)",
        "subtitle": "1,50€*/Scan"
      }
    }
  },
  "en": {
    "label": {
      "amount": "equals {amount} Scans",
      "vat-info": "* plus VAT"
    },
    "credits": {
      "basic-50": {
        "title": "50 Credits (9.50€*)",
        "subtitle": "1.90€*/Scan"
      },
      "basic-250": {
        "title": "250 Credits (45€*)",
        "subtitle": "1.80€*/Scan"
      },
      "basic-1000": {
        "title": "1000 Credits (170€*)",
        "subtitle": "1.70€*/Scan"
      },
      "pro-300": {
        "title": "300 Credits (51€*)",
        "subtitle": "1.70€*/Scan"
      },
      "pro-1000": {
        "title": "1000 Credits (160€*)",
        "subtitle": "1.60€*/Scan"
      },
      "pro-2000": {
        "title": "2000 Credits (300€*)",
        "subtitle": "1.50€*/Scan"
      }
    }
  }
}
</i18n>
